import {TextFieldModule} from '@angular/cdk/text-field';
import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {NxErrorModule} from '@aposin/ng-aquila/base';
import {NxButtonModule} from '@aposin/ng-aquila/button';
import {NxCheckboxModule} from '@aposin/ng-aquila/checkbox';
import {NxCopytextModule} from '@aposin/ng-aquila/copytext';
import {NxDatefieldModule} from '@aposin/ng-aquila/datefield';
import {NxDropdownModule} from '@aposin/ng-aquila/dropdown';
import {NxFileUploaderModule} from '@aposin/ng-aquila/file-uploader';
import {NxFormfieldModule} from '@aposin/ng-aquila/formfield';
import {NxGridModule} from '@aposin/ng-aquila/grid';
import {NxHeadlineModule} from '@aposin/ng-aquila/headline';
import {NxIconModule} from '@aposin/ng-aquila/icon';
import {NxImageModule} from '@aposin/ng-aquila/image';
import {NxInputModule} from '@aposin/ng-aquila/input';
import {NxLinkModule} from '@aposin/ng-aquila/link';
import {NxMaskModule} from '@aposin/ng-aquila/mask';
import {NxMessageModule} from '@aposin/ng-aquila/message';
import {NxDialogService, NxModalModule} from '@aposin/ng-aquila/modal';
import {NxMomentDateModule} from '@aposin/ng-aquila/moment-date-adapter';
import {NxPopoverModule} from '@aposin/ng-aquila/popover';
import {NxProgressStepperModule} from '@aposin/ng-aquila/progress-stepper';
import {NxRadioModule} from '@aposin/ng-aquila/radio-button';
import {NxRadioToggleModule} from '@aposin/ng-aquila/radio-toggle';
import {NxSpinnerModule} from '@aposin/ng-aquila/spinner';
import {NxSwitcherModule} from '@aposin/ng-aquila/switcher';
import {DynamicComponentModule} from '../dynamic-components/dynamic-component.module';
import {AzFormsComponent} from './az-forms.component';
import {CheckboxFormComponent} from './components/checkbox-form/checkbox-form.component';
import {CheckboxLinkComponent} from './components/checkbox-link/checkbox-link.component';
import {CustomFieldComponent} from './components/custom-component/custom-component.component';
import {CustomLinkComponent} from './components/custom-link/custom-link.component';
import {DateFormComponent} from './components/date-form/date-form.component';
import {ErrorBoxComponent} from './components/error-box/error-box.component';
import {CountErrorsPipe} from './components/error-box/pipes/count-errors/count-errors.pipe';
import {FormComponent} from './components/form/form.component';
import {IbanFormComponent} from './components/iban-form/iban-form.component';
import {InfoFormComponent} from './components/info-form/info-form.component';
import {InputFormComponent} from './components/input-form/input-form.component';
import {LinksComponent} from './components/links/links.component';
import {ModalConfirmReceiptComponent} from './components/modal-confirm-receipt/modal-confirm-receipt.component';
import {ModalErrorComponent} from './components/modal-error/modal-error.component';
import {ModalFormComponent} from './components/modal-form/modal-form.component';
import {ModalLoadingComponent} from './components/modal-loading/modal-loading.component';
import {NotificationBoxComponent} from './components/notification-box/notification-box.component';
import {PopoverFormComponent} from './components/popover-form/popover-form.component';
import {PrivacyCheckboxFormComponent} from './components/privacy-checkbox-form/privacy-checkbox-form.component';
import {RadioComponent} from './components/radio/radio.component';
import {SelectFormComponent} from './components/select-form/select-form.component';
import {StepComponent} from './components/step/step.component';
import {SwitcherFormComponent} from './components/switcher-form/switcher-form.component';
import {TextAreaComponent} from './components/text-area/text-area.component';
import {TextBoxComponent} from './components/text-box/text-box.component';
import {TitleFormComponent} from './components/title-form/title-form.component';
import {ToggleButtonComponent} from './components/toggle-button/toggle-button.component';
import {UnknownFormTypeComponent} from './components/unknown-form-type/unknown-form-type.component';
import {UploadDeleteComponent} from './components/upload-file-form/components/upload-delete/upload-delete.component';
import {UploadNameComponent} from './components/upload-file-form/components/upload-name/upload-name.component';
import {UploadSizeComponent} from './components/upload-file-form/components/upload-size/upload-size.component';
import {UploadStatusComponent} from './components/upload-file-form/components/upload-status/upload-status.component';
import {UploadFileFormComponent} from './components/upload-file-form/upload-file-form.component';
import {CustomMaskComponent} from './custom-mask/component/custom-mask/custom-mask.component';
import {CustomMaskDirective} from './custom-mask/custom-mask.directive';
import {DateFormatterDirective} from './directives/date-formatter/date-formatter.directive';
import {DateValidatorDirective} from './directives/date-validator/date-validator.directive';
import {DisabledDirective} from './directives/disabled/disabled.directive';
import {GenericFieldDirective} from './directives/generic-field/generic-field.directive';
import {ScrollDirective} from './directives/scroll/scroll.directive';
import {ArrayKeysPipe} from './pipes/array-keys/array-keys.pipe';
import {AutocompleteSlicePipe} from './pipes/autocomplete-slice/autocomplete-slice.pipe';
import {CheckSelectedPipe} from './pipes/check-selected/check-selected.pipe';
import {CustomTranslatePipe} from './pipes/custom-translate/custom-translate.pipe';
import {DateConverterPipe} from './pipes/date-converter/date-converter.pipe';
import {DynCompConverterPipe} from './pipes/dyn-comp-converter/dyn-comp-converter.pipe';
import {ErrorArrayKeysPipe} from './pipes/error-array-keys/error-array-keys.pipe';
import {FieldClassesPipe} from './pipes/field-classes/field-classes.pipe';
import {FieldColumnsPipe} from './pipes/field-columns/field-columns.pipe';
import {GetFieldDataPipe} from './pipes/get-field-data/get-field-data.pipe';
import {JoinStringsPipe} from './pipes/join-strings/join-strings.pipe';
import {KeyValueArrayPipe} from './pipes/key-value-array.pipe';
import {TypeofCheckPipe} from './pipes/typeof-check/typeof-check.pipe';
import {ErrorHandlerService} from './services/error-handler/error-handler.service';
import {FieldService} from './services/field/field.service';
import {FormService} from './services/form/form.service';
import {TranslateModule} from '@ngx-translate/core';
@NgModule({
  declarations: [
    FormComponent,
    ModalFormComponent,
    InputFormComponent,
    SelectFormComponent,
    UploadFileFormComponent,
    InfoFormComponent,
    TextAreaComponent,
    PrivacyCheckboxFormComponent,
    CheckboxLinkComponent,
    ScrollDirective,
    LinksComponent,
    TitleFormComponent,
    FieldColumnsPipe,
    ArrayKeysPipe,
    ErrorArrayKeysPipe,
    PopoverFormComponent,
    TypeofCheckPipe,
    ModalConfirmReceiptComponent,
    RadioComponent,
    TextBoxComponent,
    ModalErrorComponent,
    ModalLoadingComponent,
    KeyValueArrayPipe,
    CheckboxFormComponent,
    CustomLinkComponent,
    DateFormComponent,
    AutocompleteSlicePipe,
    DateValidatorDirective,
    CustomMaskDirective,
    CustomMaskComponent,
    GenericFieldDirective,
    DynCompConverterPipe,
    AzFormsComponent,
    StepComponent,
    UnknownFormTypeComponent,
    NotificationBoxComponent,
    DateConverterPipe,
    DateFormatterDirective,
    CustomFieldComponent,
    SwitcherFormComponent,
    IbanFormComponent,
    DisabledDirective,
    UploadDeleteComponent,
    UploadSizeComponent,
    UploadStatusComponent,
    UploadNameComponent,
    ToggleButtonComponent,
    FieldClassesPipe,
    CheckSelectedPipe,
    JoinStringsPipe,
    ErrorBoxComponent,
    CustomTranslatePipe,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NxInputModule,
    NxFormfieldModule,
    NxIconModule,
    NxGridModule,
    NxDropdownModule,
    NxCheckboxModule,
    NxButtonModule,
    NxFileUploaderModule,
    NxMomentDateModule,
    NxLinkModule,
    NxHeadlineModule,
    NxMessageModule,
    NxModalModule,
    NxErrorModule,
    NxMaskModule,
    TextFieldModule,
    NxPopoverModule,
    NxImageModule,
    NxRadioModule,
    NxSpinnerModule,
    NxCopytextModule,
    NxDatefieldModule,
    DynamicComponentModule,
    NxProgressStepperModule,
    NxSwitcherModule,
    NxRadioToggleModule,
    GetFieldDataPipe,
    CountErrorsPipe,
    TranslateModule,
  ],
  providers: [ErrorHandlerService, FormService, FieldService, NxDialogService],

  exports: [
    AzFormsComponent,
    ModalErrorComponent,
    ModalConfirmReceiptComponent,
    ModalLoadingComponent,
    CustomMaskDirective,
    CustomMaskComponent,
    DynCompConverterPipe,
    CustomFieldComponent,
    ToggleButtonComponent,
    RadioComponent,
    ErrorBoxComponent,
    CheckboxFormComponent,
    CustomTranslatePipe,
  ],
})
export class AzFormsModule {}
